import { type Clip, ClipStatus, ClipType } from '@air/api/types';

/**
 * This function checks if the version is a file preview.
 *
 * @param version - The version to check if it is a file preview
 * @returns True if the version is a file preview, false otherwise
 */
export const isVersionFilePreview = (version: Clip) => {
  const isFileType = [ClipType.nonMedia, ClipType.animated].includes(version.type);
  const isNonTranscodable = [ClipStatus.nonTranscodable, ClipStatus.failed].includes(version.status);

  return isFileType || isNonTranscodable;
};
